import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-toolbox-talks-templates-importer',
  templateUrl: './toolbox-talks-templates-importer.component.html',
  styleUrls: ['./toolbox-talks-templates-importer.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ToolboxTalksTemplatesImporterComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
